/**
 * QwickForge IDE Application Configuration
 *
 * Configuration for the QwickForge IDE web portal.
 * Provides AI agent orchestration interface with device pairing
 * and real-time collaboration features.
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */

import { AppConfigBuilder } from '@qwickapps/react-framework/config';

/**
 * QwickForge IDE application configuration
 * Built using the AppConfigBuilder for validation and immutability.
 */
export default AppConfigBuilder
  .create()
  // Application Identity
  .withName("QwickForge IDE - AI Development Platform")
  .withId("com.qwickapps.qwickforge.ide")
  .withShortName("QwickForge IDE")
  .withDescription("Run AI agents on your own hardware. Coordinate, collaborate, and track your AI-powered development workflow.")
  .withVersion("0.1.0")
  .withLogo("./favicon.ico")
  .withAuthor("QwickApps")
  .withHomepage("https://qwickforge.com/ide")

  // Build Configuration
  .withPort(5174)
  .withPreviewPort(4174)
  .withOutputDir("dist")
  .withPublicPath("/ide/")
  .withBase("/ide/")

  // PWA Configuration (future)
  .withThemeColor("#03bbca") // QwickForge brand color
  .withBackgroundColor("#1a1a1a") // Dark background
  .withStartUrl("/ide/")
  .withScope("/ide/")
  .withDisplay("standalone")

  // UI Configuration
  .withDefaultTheme("dark")
  .withDefaultPalette("autumn") // QwickForge cosmic palette
  .withScaffolding(true)
  .withThemeSwitcher(true)
  .withPaletteSwitcher(true) // Lock to cosmic palette for brand consistency

  // Copyright Configuration
  .withCopyright("auto", "QwickApps")

  // Build and validate
  .build();
